import dayjs from "dayjs";
import { isNotVoid } from "@/shared/utils";
import type { Dayjs } from "dayjs";
import type { MaybeType } from "@/shared/types";
import type { BirthdaySDate } from "@/services/api/entities/person/types";

export const formatSDate = (date: BirthdaySDate, currentDate: Dayjs): MaybeType<string> => {
  const { day, month } = date;

  const currentMonth = currentDate.month() + 1;
  const currentYear = currentDate.year();

  const monthValue = month ?? currentMonth;

  if (isNotVoid(day)) {
    return dayjs(`${currentYear}-${monthValue}-${day}`).format("YYYY-MM-DD");
  }

  return null;
};
